import { useState, useEffect } from 'react';

const DEFAULT_CONFIG = {
  themes: {
    univen: {
      TOKKO_HOST: 'http://localhost:8000',
      FICHA_INFO_BASE_URL: 'http://localhost:3100',
    },
  },
  config: {
    TOKKO_HOST: 'http://localhost:8000',
    FICHA_INFO_BASE_URL: 'http://localhost:3100',
    METRICS_COLLECTOR_HOST: 'http://localhost:8001',
    WHATSAPP_META_APP_ID: '903450412423977',
    WHATSAPP_META_CONFIG_ID: '2309219966280815',
    WHATSAPP_AUTH_SERVICE_URL: 'https://messenger.tokkobroker.com/meta/login',
    WHATSAPP_AUTH_ROUTING_ENV:
      process.env.NEXT_PUBLIC_WHATSAPP_AUTH_ROUTING_ENV || '',
  },
};

let configCache = null;
let configPromise = null;

const fetchConfig = async () => {
  if (configCache) {
    return configCache;
  }

  if (configPromise) {
    return configPromise;
  }

  configPromise = (async () => {
    if (process.env.NODE_ENV === 'development') {
      configCache = DEFAULT_CONFIG;
      return DEFAULT_CONFIG;
    }

    try {
      const response = await fetch(`/env.js?${Date.now()}`);

      if (response.ok) {
        const jsContent = await response.text();

        try {
          // Create a controlled window object to capture the _env assignment
          // eslint-disable-next-line no-underscore-dangle
          const mockWindow = { _env: null };

          // Use Function constructor for safer execution than eval
          // eslint-disable-next-line no-new-func
          const executeJS = new Function('window', jsContent);
          executeJS(mockWindow);

          // eslint-disable-next-line no-underscore-dangle
          const envVars = mockWindow._env;

          if (envVars) {
            configCache = envVars;
            return envVars;
          }

          console.warn('Runtime config: _env was not set in executed JS');
        } catch (executionError) {
          console.warn(
            'Runtime config: JS execution failed:',
            executionError.message
          );
        }
      } else {
        console.warn(
          'Runtime config: Failed to fetch /env.js, status:',
          response.status
        );
      }
    } catch (error) {
      console.warn(
        'Runtime config: Network error fetching /env.js:',
        error.message
      );
    }

    // Fallback to default configuration
    configCache = DEFAULT_CONFIG;
    return DEFAULT_CONFIG;
  })();

  return configPromise;
};

const useRuntimeConfig = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchConfig()
      .then(setConfig)
      .finally(() => setLoading(false));
  }, []);

  const refetch = async () => {
    configCache = null;
    configPromise = null;
    setLoading(true);

    const newConfig = await fetchConfig();
    setConfig(newConfig);
    setLoading(false);
    return newConfig;
  };

  return {
    config: config || DEFAULT_CONFIG,
    loading,
    refetch,
  };
};

export default useRuntimeConfig;
